const applyPermisConsolideDeleteVisibility = () => {
  const page = document.querySelector('#permis-consolides-page');
  if (!page) return;

  const isTrue = (value) => ['true', '1', 'yes'].includes(String(value).toLowerCase());
  const canManagePermits = isTrue(page.dataset.pcCanManagePermits);
  const isAdmin = isTrue(page.dataset.pcIsAdmin);
  const currentUserId = String(page.dataset.pcCurrentUserId || '').trim();

  page.querySelectorAll('[data-pc-delete-cell]').forEach((cell) => {
    const status = String(cell.dataset.pcStatus || '').trim().toLowerCase();
    const isActive = isTrue(cell.dataset.pcActive);
    const ownerId = String(cell.dataset.pcOwnerId || '').trim();
    const isOwner = Boolean(currentUserId) && Boolean(ownerId) && currentUserId === ownerId;
    const isDeletableStatus = status === 'completed' || status === 'failed' || status === 'cancelled';
    const canDelete = isDeletableStatus && (isAdmin || (canManagePermits && isOwner && !isActive));
    const controls = cell.querySelectorAll('[data-pc-delete-control]');
    const hasControls = controls.length > 0;

    controls.forEach((control) => {
      control.classList.toggle('fr-hidden', !canDelete);
    });

    const placeholder = cell.querySelector('[data-pc-delete-placeholder]');
    if (placeholder) {
      placeholder.classList.toggle('fr-hidden', hasControls && canDelete);
    }
  });
};

let permisConsolidesObserver = null;

const initPermisConsolideDeleteVisibilityObserver = () => {
  const page = document.querySelector('#permis-consolides-page');
  if (!page) return;

  if (permisConsolidesObserver) {
    permisConsolidesObserver.disconnect();
  }

  permisConsolidesObserver = new MutationObserver(() => {
    applyPermisConsolideDeleteVisibility();
  });

  permisConsolidesObserver.observe(page, { childList: true, subtree: true });
};

document.addEventListener('DOMContentLoaded', applyPermisConsolideDeleteVisibility);
document.addEventListener('turbo:load', applyPermisConsolideDeleteVisibility);
document.addEventListener('turbo:render', applyPermisConsolideDeleteVisibility);
document.addEventListener('turbo:load', initPermisConsolideDeleteVisibilityObserver);
document.addEventListener('turbo:render', initPermisConsolideDeleteVisibilityObserver);

document.addEventListener('turbo:before-stream-render', () => {
  requestAnimationFrame(applyPermisConsolideDeleteVisibility);
});

applyPermisConsolideDeleteVisibility();
initPermisConsolideDeleteVisibilityObserver();
